export default __webpack_public_path__ + "static/media/1.bf119f29.svg";